import React, { useState, useContext } from "react";
import { Navigate, NavLink } from "react-router-dom";
import Header from "../../components/header/Header";
import { useForm } from "react-hook-form";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import InputField from "../../components/inputField/InputField";
import styles from "./LoginPage.module.css";
import Button from "../../components/button/Button";
import { apiUrl } from "../../constants";

const LoginPage = () => {
  const [errorMessage, toggleErrorMessage] = useState(false);
  const [errorMessageWrongCredentials, toggleErrorMessageWrongCredentials] =
    useState(false);
  const [loading, toggleLoading] = useState(false);
  const { login, user } = useContext(AuthContext);

  const showNavigation = false;
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  // Send the login data to the database and login and navigate to the search page.
  async function onSubmit(data) {
    toggleErrorMessage(false);
    toggleLoading(true);
    try {
      const result = await axios.post(`${apiUrl}/api/auth/login`, data);
      if (result.data === "Credentials do not match.") {
        toggleErrorMessageWrongCredentials(true);
      } else {
        login(result.data.token, result);
      }
    } catch (e) {
      toggleErrorMessage(true);
    }
    toggleLoading(false);
  }
  if (user) {
    return <Navigate to="/search" />;
  }

  return (
    <div>
      <Header showNavigation={showNavigation} />
      <div className={styles.page}>
        <div className={styles.container}>
          <article>
            <h1>Sign in</h1>
            <form
              className={styles["login-form"]}
              onSubmit={handleSubmit(onSubmit)}
            >
              <section>
                <InputField
                  label="Email"
                  fieldRef={register("email", { required: true })}
                  name="email"
                  type="text"
                  id="email-sign-in-field"
                />
                {errors.email && (
                  <p className={styles.error}>Email is required</p>
                )}
              </section>

              <section>
                <InputField
                  label="Password"
                  fieldRef={register("password", { required: true })}
                  name="password"
                  type="password"
                  id="password-sign-in-field"
                />
                {errors.password && (
                  <p className={styles.error}>Password is required</p>
                )}
              </section>

              <section className={styles["sign-in-button-wrapper"]}>
                <Button type="submit">SIGN IN</Button>
              </section>
            </form>
            <div className={styles["reset-link-wrapper"]}>
              <NavLink className={styles["reset-link"]} to="/forgottenpassword">
                Reset password
              </NavLink>
            </div>

            {errorMessage && (
              <div className={styles["error-wrapper"]}>
                <span className={styles.error}>
                  Something went wrong with logging you in, please try again
                  later.
                </span>
              </div>
            )}

            {errorMessageWrongCredentials && (
              <div className={styles["error-wrapper"]}>
                <span className={styles.error}>
                  Your password and/or email is incorrect. Please try again.
                </span>
              </div>
            )}

            <div className={styles["loading-wrapper"]}>
              {loading && <p className={styles.loading}>Loading...</p>}
            </div>
          </article>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
